/**
 * Labstep
 *
 * @module components/ResourceLocation/Item/StockCheck
 * @desc ResourceLocation StockCheck item
 */

import { EntityLink } from 'labstep-web/components/Entity/Link';
import { ResourceItemActionUpdateStockCheck } from 'labstep-web/components/ResourceItem/Action/UpdateStockCheck';
import { ICONS } from 'labstep-web/constants/icons';
import { ElementCard } from 'labstep-web/core/Card/Element';
import type React from 'react';
import type { IResourceLocationItemStockCheckProps } from './types';

export const ResourceLocationItemStockCheck: React.FC<
  IResourceLocationItemStockCheckProps
> = ({ resourceItem }) => (
  <ElementCard
    icon={ICONS.resource_item.primary}
    name={<EntityLink entity={resourceItem} />}
    actions={
      <ResourceItemActionUpdateStockCheck
        resourceItem={resourceItem}
      />
    }
  />
);
